import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import moment from "moment"; // Import moment for date formatting
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useTranslation } from "react-i18next";
import { API_CREATE_COUPEN } from "api/coupen-management";
import { API_LIST_PLAN } from "api/plan-management";
import { useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import Select from "react-select";

const CreateCoupon = () => {
  const [data, setData] = useState();
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const [selectedOptionPlans, setSelectedOptionPlans] = useState();
  const handleOptionChangePlans = (selectedOptions) => {
    setSelectedOptionPlans(selectedOptions);
    console.log(selectedOptions); // This will log an array of selected options
  };
  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_PLAN(params);
      console.log("coupen", newData);
      setData(newData?.plans);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const options = data?.map((option, index) => ({
    value: option?._id,
    label: option?.plan_type,
  }));
  useEffect(() => {
    fetchData();
  }, []);
  console.log("selectedOptionPlans", selectedOptionPlans);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              coupon_title: "",
              coupon_description: "",
              coupon_expiry_date: "",
              coupon_start_date: "",
              coupon_type: "percentage",
              coupon_discount: "",
              discount_for_plan: "",
              discount_for_plan: "",
            }}
            validationSchema={Yup.object({
              coupon_title: Yup.string()
                .required("Required")
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              coupon_description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              coupon_expiry_date: Yup.string().required("Required"),
              coupon_start_date: Yup.string().required("Required"),
              coupon_type: Yup.string()
                .required("Required")
                .oneOf(
                  ["fixed", "percentage"],
                  "Must be 'fixed' or 'percentage'"
                ),
              coupon_discount: Yup.number().required("Required"),
              // discount_for_plan: Yup.array().min(1, "Select at least one plan"),
              // discount_for_plan: Yup.string().required("Required"),
              discount_for_plan: Yup.array().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                // Extract coupon-related values
                const payload = {
                  ...values,
                  // discount_for_plan: [values?.discount_for_plan?._id],
                  discount_for_plan: selectedOptionPlans?.map(
                    (plan) => plan?.value
                  ),

                  coupon_expiry_date: moment(values.coupon_expiry_date).unix(),
                  coupon_start_date: moment(values.coupon_start_date).unix(),
                };
                const userData = await API_CREATE_COUPEN(payload);
                Navigate("/admin/main-coupon-management/coupon-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div
                  className="mb-4 flex w-[6rem] cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Title")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_title"
                        placeholder={t("Coupon Title")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="coupon_title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={6}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Start Date")}
                        <span className="text-[red]">*</span>
                      </label>
                      <DatePicker
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        selected={values.coupon_start_date} // Use `selected` prop instead of `value`
                        onChange={(date) =>
                          setFieldValue("coupon_start_date", date)
                        }
                        dateFormat="yyyy-MM-dd" // Set your desired date format
                        placeholderText={t("Coupon Start Date")}
                        minDate={new Date()}
                      />

                      <ErrorMessage
                        name="coupon_start_date"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Expiry Date")} <span className="text-[red]">*</span>
                      </label>

                      <DatePicker
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        selected={values.coupon_expiry_date} // Use `selected` prop instead of `value`
                        onChange={(date) =>
                          setFieldValue("coupon_expiry_date", date)
                        }
                        disabled={!values?.coupon_start_date}
                        dateFormat="yyyy-MM-dd" // Set your desired date format
                        placeholderText={t("Expiry Date")}
                        minDate={values?.coupon_start_date} // Set the minDate prop
                      />
                      <ErrorMessage
                        name="coupon_expiry_date"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Type")} <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Coupon Type")}{" "}
                      </label> */}
                      {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="coupon_type"
                        placeholder={t("Coupon Type")}
                      /> */}

                      <Field
                        as="select"
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="coupon_type"
                      >
                        <option value="percentage">{"Percentage"}</option>
                        <option value="fixed">{t("Fixed")}</option>
                      </Field>
                      <ErrorMessage
                        name="coupon_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Discount")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_discount"
                        placeholder={
                          values?.coupon_type == "fixed"
                            ? t("Enter Amount in SAR")
                            : t("Enter Discount percentage Amount")
                        }
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="coupon_discount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Discount for Plan")}{" "}
                        <span className="text-[red]">*</span>
                      </label>

                      <Select
                        className="mt-2 flex h-11 w-full items-center  rounded-xl  border-2 border-gray-300 bg-white p-3  text-sm outline-none"
                        onChange={(value) => {
                          setFieldValue("discount_for_plan", value);
                          handleOptionChangePlans(value);
                        }}
                        options={options}
                        name="discount_for_plan"
                        isMulti
                        placeholder={t("Select options")}
                        value={selectedOptionPlans}
                      />

                      {/* <Field
                        as="select" // Using select element
                        // multiple // Allowing multiple selections
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        name="discount_for_plan"
                      >
                        <option value={""}>Select Discount plan</option>
                        {data?.map((value, index) => {
                          return (
                            <option key={index} value={value}>
                              {value?.plan_type}
                            </option>
                          );
                        })}{" "}
                      </Field> */}
                      <ErrorMessage
                        name="discount_for_plan"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")} <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block min-h-28  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_description"
                        placeholder={t("Coupon Description")}
                      />
                      <ErrorMessage
                        name="coupon_description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Coupen")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateCoupon;
